import { render, staticRenderFns } from "./ProductPrices.vue?vue&type=template&id=cd8f6894&scoped=true&"
import script from "./ProductPrices.vue?vue&type=script&lang=js&"
export * from "./ProductPrices.vue?vue&type=script&lang=js&"
import style0 from "./ProductPrices.vue?vue&type=style&index=0&id=cd8f6894&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8f6894",
  null
  
)

export default component.exports